export default __webpack_public_path__ + "static/media/github.fa0212fe.svg";